<div class="nplPage priceListPageClass-wrapper" style="text-align: center; width: 80%;">
  <div class="page-heading">
    <div class="row">
      <div class="col-8">
        <h5 class="text-left" style="font-size: 18px">AMS Pricing- Full Truck Load, Direct Ship</h5>
      </div>
      <div class="col-4 subscribe-sec text-right m-auto padding-r0">
        <span class="manage-subs">
          <i class="fa fa-envelope" aria-hidden="true"></i>
          <a href="Javascript:void(0);" class="" (click)="redirectToSubscription()">Manage Subscriptions</a>
        </span>
        <span class="manage-subs">
          <img src="../assets/icon/svg/manage-reports.svg" (click)="selectFilter()" />
          <a href="Javascript:void(0);" (click)="selectFilter()">MANAGE REPORTS</a>
        </span>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="text-left">
          <h5 style="font-size: 16px">51 pound bags are palletized bags.  Minimum order quantity is 42,840 pounds.</h5>
          <h5 style="font-size: 16px">MR bag BLK and APF 2000 LBS are 2000 pound totes sacks.  Minimum order quantity is 42,000 pounds.</h5>
          <h5 style="font-size: 16px">Pricing is based on location to account for variable freight costs.</h5>
        </div>
      </div>
    </div>
  </div>
  <div class="nplPage priceListPageClass-wrapper" style="width: 100%; margin:0;">
    <div class="priceLists margin-0">
      <div class="topSection">
        <div class="alignTopSec">
          <div class="form-sec">
            <div class="col-sm-12 col-md-12 col-lg-12 smallPadRgt0 padding-l0">
              <div class="row search-box-outer ">
                <div class="col-3 padding-r30">
                  <div class="category-dropdown material-select">
                    <ng-select [items]="stateData" [clearSearchOnAdd]="true"
                               [closeOnSelect]="false" labelForId="state" [multiple]="true" placeholder="Select State"
                               [(ngModel)]="searchstate" (change)="filterRecords()" [searchFn]="ddlOptionsSearchState"
                               [selectableGroupAsModel]="false" groupBy="selectedAllGroupbranchState" [selectableGroup]="true" bindValue="state"
                               [keyDownFn]="handleKeyevent" clearAllText="Clear" [bindLabel]="'text'">
                      <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">
                        <div class="row">
                          <input id="item-{{index}}" type="checkbox"
                                 [ngModel]="item$.selected" />{{'Select All'}}
                        </div>
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                        <div class="row">
                          <input id="item-{{index
                          }}" type="checkbox" [ngModel]="item$.selected" [ngModelOptions]="{standalone: true}" />
                          {{item.state}}
                        </div>
                      </ng-template>
                      <ng-template ng-multi-label-tmp let-items="items">
                        <div class="ng-value" *ngFor="let item of items | slice:0:2">
                          {{item.state}}
                        </div>
                        <div class="ng-value" *ngIf="items.length > 2">
                          <span class="ng-value-label">{{items.length - 2}} more...</span>
                        </div>
                      </ng-template>
                      <ng-template ng-multi-label-tmp let-items="items">
                        <div class="ng-value" *ngFor="let item of items | slice:0:2">
                          {{item['text']}}
                        </div>
                        <div class="ng-value" *ngIf="items.length > 2">
                          <span class="ng-value-label">{{items.length - 2}} more...</span>
                        </div>
                      </ng-template>
                    </ng-select>
                  </div>
                </div>
                <div class="col-3 padding-r30">
                  <div class="category-dropdown material-select">
                    <ng-select [items]="branchPlantData" [clearSearchOnAdd]="true"
                               [closeOnSelect]="false" labelForId="branchPlant" [multiple]="true" placeholder="Select Branch Plant"
                               [(ngModel)]="searchbranchPlant" (change)="filterRecords()" [searchFn]="ddlOptionsSearchBranchPlantData"
                               [selectableGroupAsModel]="false" groupBy="selectedAllGroupbranchPlant" [selectableGroup]="true" bindValue="branchPlant"
                               [keyDownFn]="handleKeyevent" clearAllText="Clear" [bindLabel]="'text'">
                      <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">
                        <div class="row">
                          <input id="item-{{index}}" type="checkbox"
                                 [ngModel]="item$.selected" /> Select All
                        </div>
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                        <div class="row">
                          <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected" [ngModelOptions]="{standalone: true}" />
                          {{item.branchPlant}}
                        </div>
                      </ng-template>
                      <ng-template ng-multi-label-tmp let-items="items">
                        <div class="ng-value" *ngFor="let item of items | slice:0:2">
                          {{item.branchPlant}}
                        </div>
                        <div class="ng-value" *ngIf="items.length > 2">
                          <span class="ng-value-label">{{items.length - 2}} more...</span>
                        </div>
                      </ng-template>
                      <ng-template ng-multi-label-tmp let-items="items">
                        <div class="ng-value" *ngFor="let item of items | slice:0:2">
                          {{item['text']}}
                        </div>
                        <div class="ng-value" *ngIf="items.length > 2">
                          <span class="ng-value-label">{{items.length - 2}} more...</span>
                        </div>
                      </ng-template>
                    </ng-select>
                  </div>
                </div>
                <div class="col-6 search-btn text-right m-auto">
                  <button mat-raised-button class="btns" color="primary" (click)="onExportBtnClick()" [disabled]="AMSPricingListDataSource?.data.length <= 0">Export Data in Excel</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="middleSection">
        <div class="col-md-12 padding-l30 padding-b10 padding-t10">
          <div class="row">
            <div class="col-md-8 padding-r30 padding-l0 text-left">
              <div class="row">
                <div class="col-md-3 my-auto">
                  <p class="mb-0" *ngIf="currentFilter.filterDescription">REPORT NAME: {{currentFilter.filterDescription}}</p>
                </div>
                <div class="col-md-3 my-auto">
                  <p class="mb-0" *ngIf="currentFilter.filterDescription">
                    LAST RUN DATE: {{(currentFilter.lastRunByTimeStamp || currentFilter.createTimeStamp) | date: 'MM/dd/yyyy'}}
                  </p>
                </div>
                <div class="col-md-3 padding-l0 padding-r0">
                  <button mat-raised-button class="btns margin-r10" color="primary" (click)="editFilter()" *ngIf="(currentFilter.userReportFilterId || !(currentFilter.userReportFilterId)) && currentFilter.filterDescription">Edit Report</button>
                  <button mat-raised-button class="btns margin-r10" color="primary" (click)="save()" *ngIf="currentFilter.filterDescription">Save</button>
                </div>
              </div>
            </div>
            <div class="col-md-4 text-right">
              <div class="row">
                <div class="col-md-7 my-auto">
                  <p class="mb-0 text-uppercase">Last Refresh Date: <span>{{UpdateTimestamp | date:'MM/dd/yyyy' }}</span></p>
                </div>
                <div class="col-md-5">
                  <button mat-raised-button class="btns wide100" color="primary" (click)="addFilter()">Create Report</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="bottomSection">
        <div class="row">
          <div class="col-md-12 productTableOuter">
            <div class="tableContainer priceListTable" id="AMSPrincing">
              <table mat-table #placedCPPOrdersTable [dataSource]="AMSPricingListDataSource" multiTemplateDataRows class="matTables">
                <ng-container matColumnDef="state">
                  <th mat-header-cell *matHeaderCellDef> State </th>
                  <td mat-cell *matCellDef="let element"> {{element.state}} </td>
                </ng-container>
                <ng-container matColumnDef="branchPlant">
                  <th mat-header-cell *matHeaderCellDef> Branch Plant </th>
                  <td mat-cell *matCellDef="let element"> {{element.branchPlant}} </td>
                </ng-container>
                <ng-container matColumnDef="secondItemNumber">
                  <th mat-header-cell *matHeaderCellDef class="pb-2">
                    Item Number
                    <div>
                      <mat-form-field>
                        <mat-label>Item Number Filter</mat-label>
                        <input matInput [(ngModel)]="filteredValues.secondItemNumber" (ngModelChange)="filterByItemNumber($event)" />
                      </mat-form-field>
                    </div>
                  </th>
                  <td mat-cell *matCellDef="let element"> {{element.secondItemNumber}} </td>
                </ng-container>
                <ng-container matColumnDef="itemDesc">
                  <th mat-header-cell *matHeaderCellDef class="pb-2">
                    Item Description
                    <div>
                      <mat-form-field>
                        <mat-label>Item Desc Filter</mat-label>
                        <input matInput [(ngModel)]="filteredValues.itemDesc" (ngModelChange)="filterByItemDesc($event)" />
                      </mat-form-field>
                    </div>
                  </th>
                  <td mat-cell *matCellDef="let element"> {{element.itemDesc}} </td>
                </ng-container>
                <ng-container matColumnDef="itemDesc2">
                  <th mat-header-cell *matHeaderCellDef>
                    Package Size
                  </th>
                  <td mat-cell *matCellDef="let element"> {{element.itemDesc2}} </td>
                </ng-container>
                <ng-container matColumnDef="price">
                  <th mat-header-cell *matHeaderCellDef> Price </th>
                  <td mat-cell *matCellDef="let element"> {{element.price}} </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              </table>
              <div *ngIf="AMSPricingListDataSource == undefined || AMSPricingListDataSource?.data.length == 0" class="noDataMsg">
                <p>No PriceList found.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
